import { render } from "./Privatnost.vue?vue&type=template&id=973c3000"
import script from "./Privatnost.vue?vue&type=script&lang=js"
export * from "./Privatnost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__